import React, { useEffect } from "react";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { initializePosthog, posthog } from "../services/posthogService";
export { posthog } from "../services/posthogService";

interface PostHogProviderProps {
  children: React.ReactNode;
}

export const PostHogProvider: React.FC<PostHogProviderProps> = ({
  children,
}) => {
  // Initialize PostHog with persistence
  useEffect(() => {
    void initializePosthog();
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
};
